module.exports = __webpack_public_path__ + "img/button_help.3681d12c.png";